import { createTableSlice } from 'features/dashboard/table/createTableSlice'
import { DashboardTypes } from 'features/Codes'
import { serializeError } from 'utils'
import api from 'api/axios/foka'
import { filterMetricColumns } from 'features/dashboard/utils/dashboardUtils'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchAdGroupSummary = createAsyncThunk(
  'dashboard/fetchAdGroupSummary',
  async ({ from, to, columns, campaignIds, filters }) => {
    const summary = await api.dashboard
      .getAdGroupTableReportTotal({
        from,
        to,
        columns,
        campaignIds,
        filters,
      })
      .then(res => res?.data?.reportResponse?.data[0] || {})
      .catch(() => ({}))
    return { summary }
  }
)

export const fetchAdGroupTable = createAsyncThunk(
  'dashboard/fetchAdGroupTable',
  async (noArgs, { getState, dispatch, rejectWithValue }) => {
    let error
    const {
      common: { from, to },
      filter: { filters },
      table: {
        config: {
          columns: { [DashboardTypes.AD_GROUP]: columns },
        },
        campaignTable: { selectedIds: campaignIds },
        adGroupTable: { page, sort },
      },
    } = getState().dashboard
    const metricColumns = filterMetricColumns(columns)
    if (metricColumns.length > 0) {
      dispatch(
        fetchAdGroupSummary({
          from,
          to,
          columns: metricColumns,
          campaignIds,
          filters,
        })
      )
    }
    const { content, totalElements } = await api.dashboard
      .getAdGroupTable({
        from,
        to,
        page,
        sort,
        campaignIds,
        filters,
      })
      .then(res => res?.data?.result)
      .catch(err => {
        error = serializeError(err)
        return {
          content: [],
          totalElements: 0,
        }
      })
    if (error) {
      return rejectWithValue(error)
    } else {
      let metricError
      const metrics =
        totalElements === 0 || metricColumns.length === 0
          ? {}
          : await api.dashboard
              .getAdGroupTableReport({
                from,
                to,
                columns: metricColumns,
                ids: content.map(({ id }) => id),
              })
              .then(res => res?.data?.metrics)
              .catch(() => {
                metricError = '지표 데이터를 불러오지 못했습니다.'
                return {}
              })
      return {
        totalElements,
        content: content.map(item => ({
          ...item,
          ...metrics[item.id],
        })),
        error: metricError,
      }
    }
  }
)
const adGroupTableSlice = createTableSlice({
  type: DashboardTypes.AD_GROUP,
  fetcher: fetchAdGroupTable,
  summaryFetcher: fetchAdGroupSummary,
})
const { actions, reducer } = adGroupTableSlice
export const adGroupTableActions = actions
export const {
  reset,
  toggleSelectedId,
  setSelectedIds,
  setPage,
  setSort,
  clearError,
  setStatus,
} = actions
export default reducer
